import request from "@/utils/request";
const ispApi = {
  getDefaultDefine: () => {
    return request({
      url: "/trade-apply/high-end-isp/default-define",
      method: "post",
    });
  },
  getQuotaOrg: (data) => {
    return request({
      url: "/trade-apply/high-end-isp/quota/org",
      method: "post",
      data,
    });
  },
  getQuotaInfo: (data) => {
    return request({
      url: "/trade-apply/high-end-isp/default-define-quota",
      method: "post",
      data,
    });
  },
  // 分配配额
  handleQuotaConfig: (data) => {
    return request({
      url: "/trade-apply/high-end-isp/quota/config",
      method: "post",
      data,
    });
  },
};
export default ispApi;
